import { Icon } from "@iconify/react";
import Marquee from "../Marquee";
import Spacing from "../Spacing";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import EmailSender from "../../api/EmailSender";

const addressDataList = [
  "ST 13, Block 3 Clifton, Karachi",
  "+92 319 3446483",
  "info@ignitesportspavilion.com",
];
const serviceMenuList = [
  {
    title: "Padel Training & Matches",
    href: "/service",
  },
  {
    title: "Futsal Coaching & Leagues",
    href: "/service",
  },
  {
    title: "Multi Purpose Practice & Tournaments",
    href: "service",
  },
  {
    title: "Sports Events & Community Activities",
    href: "service",
  },
];
const LinksMenuList = [
  {
    title: "Home",
    href: "/",
  },
  {
    title: "About",
    href: "/about",
  },
  {
    title: "Services",
    href: "/service",
  },

  {
    title: "Contact",
    href: "/contact",
  },
];
const policyMenuList = [
  {
    title: "Terms of Use",
    href: "/terms-of-use",
  },
  {
    title: "Privacy Policy",
    href: "/privacy-policy",
  },
  {
    title: "Refund Policy",
    href: "/refund-policy",
  },
];
const socialBtnList = [
  // {
  //   icon: "fa6-brands:linkedin-in",
  //   href: "/",
  // },
  {
    icon: "fa6-brands:instagram",
    href: "https://www.instagram.com/ignitesportspavilion/reel/DKwqzpKt7s3/",
  },
  // {
  //   icon: "fa6-brands:youtube",
  //   href: "/",
  // },
  {
    icon: "fa6-brands:facebook-f",
    href: "/",
  },
];

export default function Footer() {
  const { isSubmitting, succeeded, error, sendEmail } = EmailSender();
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const location = useLocation();

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    
    if (!newsletterEmail.trim()) {
      alert('Please enter your email address');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newsletterEmail)) {
      alert('Please enter a valid email address');
      return;
    }

    const formData = {
      email: newsletterEmail,
      subscription: 'Newsletter Subscription'
    };

    const success = await sendEmail(
      formData,
      "New Newsletter Subscription - Ignite Sports Pavilion"
    );

    if (success) {
      setNewsletterEmail('');
    }
  };

  return (
    <>
      {/* <Spacing lg="135" md="70" className="mt-0"/> */}
      <Marquee text="Providing world-class courts for Padel, Futsal, and Multi Purpose" />
      <Spacing lg="120" md="50" />
      <footer
        className="cs_fooer cs_bg_filed"
        style={{ backgroundImage: "url(/images/footer_bg.png)" }}
      >
        <div className="cs_fooer_main">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-sm-6">
                <div className="cs_footer_item">
                  <div className="cs_text_widget">
                    <img src="/images/logo_white.svg" alt="Logo" />
                  </div>
                  <ul className="cs_menu_widget cs_mp0">
                    {addressDataList.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="cs_footer_item">
                  <h2 className="cs_widget_title">Services</h2>
                  <ul className="cs_menu_widget cs_mp0">
                    {serviceMenuList.map((item, index) => (
                      <li key={index}>
                        <Link 
                          to={item.href}
                          onClick={e => {
                            if (location.pathname === item.href) {
                              e.preventDefault();
                            }
                            // Always scroll to top with a slight delay to ensure it works
                            setTimeout(() => {
                              window.scrollTo({ top: 0, behavior: 'smooth' });
                            }, 100);
                          }}
                        >{item.title}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="cs_footer_item">
                  <h2 className="cs_widget_title">Links</h2>
                  <ul className="cs_menu_widget cs_mp0">
                    {LinksMenuList.map((item, index) => (
                      <li key={index}>
                        <Link 
                          to={item.href}
                          onClick={e => {
                            if (location.pathname === item.href) {
                              e.preventDefault();
                            }
                            // Always scroll to top with a slight delay to ensure it works
                            setTimeout(() => {
                              window.scrollTo({ top: 0, behavior: 'smooth' });
                            }, 100);
                          }}
                        >{item.title}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="cs_footer_item">
                  <h2 className="cs_widget_title">Subscribe Newsletter </h2>
                  <div className="cs_newsletter cs_style_1">
                    <div className="cs_newsletter_text">
                      Get updates on the latest matches, events, and exclusive
                      offers.
                    </div>
                    <form onSubmit={handleNewsletterSubmit} className="cs_newsletter_form">
                      <input
                        type="email"
                        className="cs_newsletter_input"
                        placeholder="Email address"
                        value={newsletterEmail}
                        onChange={(e) => setNewsletterEmail(e.target.value)}
                        required
                      />
                      <button 
                        className="cs_btn cs_style_1" 
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Subscribing..." : "Submit"}
                        <span>
                          <i>
                            <Icon icon="fa6-solid:arrow-right" />
                          </i>
                          <i>
                            <Icon icon="fa6-solid:arrow-right" />
                          </i>
                        </span>
                      </button>
                    </form>
                    {succeeded && (
                      <div className="alert alert-success mt-2" style={{ fontSize: '12px', color: '#28a745' }}>
                        Thank you for subscribing!
                      </div>
                    )}
                    {error && (
                      <div className="alert alert-danger mt-2" style={{ fontSize: '12px', color: '#dc3545' }}>
                        {error}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="cs_bottom_footer">
            <div className="cs_bottom_footer_left">
              <div className="cs_social_btns cs_style_1">
                {socialBtnList.map((item, index) => (
                  <Link to={item.href} className="cs_center" key={index}>
                    <Icon icon={item.icon} />
                  </Link>
                ))}
              </div>
            </div>
            <div className="cs_copyright">
              Copyright © 2025 ignite | Developed by
              <a href="http://nascentinnovations.com/ " target="_blank">
                {" "}
                Nascent Innovations
              </a>
              .
            </div>
            <div className="cs_bottom_footer_right">
              <ul className="cs_footer_links cs_mp0">
                {policyMenuList.map((item, index) => (
                  <li key={index}>
                    <Link 
                      to={item.href}
                      onClick={e => {
                        if (location.pathname === item.href) {
                          e.preventDefault();
                        }
                        // Always scroll to top with a slight delay to ensure it works
                        setTimeout(() => {
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }, 100);
                      }}
                    >{item.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
